// external imports
import React from 'react'
import { graphql, createFragmentContainer } from 'react-relay'
import { groupBy } from 'lodash'
import { FreeState, Select, Option, Label } from 'quark-web'
// local imports
import styles from './styles'
import { Text } from '~/components'

const DistributorList = ({ distributors }) => {
    // if we haven't loaded the distributors dont show anything
    if (!distributors) {
        return null
    }

    // a mapping of
    const regionMap = groupBy(distributors.edges, ({ node: distributor }) => distributor.region.name)

    return (
        <FreeState initial="">
            {({ state, set }) => {
                // the list of regions of distributors to show
                const regions = state ? [state] : Object.keys(regionMap)

                return (
                    <React.Fragment>
                        <Label value="Filter Distributors" style={styles.filterSection}>
                            <Select value={state} onChange={set} toggleStyle={styles.filterToggle}>
                                <Option value="" key="">
                                    All
                                </Option>
                                {Object.keys(regionMap).map(region => (
                                    <Option value={region} key={region}>
                                        {region}
                                    </Option>
                                ))}
                            </Select>
                        </Label>
                        {regions.map((region, i) => (
                            <div style={i === 0 ? styles.firstRegionContainer : styles.regionContainer} key={region}>
                                <Text style={styles.regionName}>{region}</Text>
                                {regionMap[region].map(({ node: distributor }) => (
                                    <div style={styles.distributorContainer} key={distributor.name}>
                                        <Text style={styles.distributorName}>{distributor.name}</Text>
                                        <Text style={styles.addressLine1}>{distributor.addressLine1}</Text>
                                        <Text style={styles.addressLine2}>{distributor.addressLine2}</Text>
                                        <Text style={styles.cityStateLine}>{distributor.cityStateLine}</Text>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </React.Fragment>
                )
            }}
        </FreeState>
    )
}

export default DistributorList



// WEBPACK FOOTER //
// ./src/views/Distributors/DistributorList/index.js